export function calcTotalPrice(price: string, quantity: number): string {
    return ((Math.round(parseFloat(price) * 100) * quantity) / 100).toFixed(2);
}
